import { render, staticRenderFns } from "./ArchiItem.vue?vue&type=template&id=c31d4a3a&scoped=true"
import script from "./ArchiItem.vue?vue&type=script&lang=js"
export * from "./ArchiItem.vue?vue&type=script&lang=js"
import style0 from "./ArchiItem.vue?vue&type=style&index=0&id=c31d4a3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31d4a3a",
  null
  
)

export default component.exports